import { render, staticRenderFns } from "./fccConfiguracaoGabarito.vue?vue&type=template&id=42344c12"
import script from "./fccConfiguracaoGabarito.vue?vue&type=script&lang=js"
export * from "./fccConfiguracaoGabarito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports